// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"702":"40e125c2","818":"9ab5ba70"}[chunkId] + ".js";
};